(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/selfservice-cart/assets/javascripts/clear-storage.js') >= 0) return;  svs.modules.push('/components/components/selfservice-cart/assets/javascripts/clear-storage.js');
"use strict";

const clearStorage = () => {
  localStorage.clear();
  svs.components.selfserviceCart.getCartInstance().actions.clearStorage();
};
setGlobal('svs.components.selfserviceCart.clearStorage', clearStorage);

 })(window);